import { connect } from 'react-redux';
import PengaturanRombel from '../../views/Settings/PengaturanRombel.view';
import {
  getUserGroups, getSchoolUnitsOptions, getParamPerwakilan,
  getPrmStaffRombel
} from '../../states/thunks/options.thunk';
import { listBlockUnits, editMasterPositions, saveMasterPositions, listRombels} from '../../states/thunks/academics.thunk';

function mapStateToProps(state) {
  return {
    classes: state.options.classes,
    levels: state.options.levels,
    user: state.user || {},
  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleListBlockUnits: (payload, goback) => dispatch(listBlockUnits(payload, goback)),
    getPrmStaffRombelOptions: payload => dispatch(getPrmStaffRombel(payload)),
    getUserGroups: payload => dispatch(getUserGroups(payload)),
    getSchoolUnitsOptions: payload => dispatch(getSchoolUnitsOptions(payload)),
    getParamPerwakilan: payload => dispatch(getParamPerwakilan(payload)),
    handleListRombels: (payload, goback) => dispatch(listRombels(payload, goback)),
    handleSaveMasterPositions: (payload, goback) => dispatch(saveMasterPositions(payload, goback)),
    handleEditMasterPositions: (payload, goback) => dispatch(editMasterPositions(payload, goback)),

  };
}

export default connect(mapStateToProps, mapDispatchToProps)(PengaturanRombel);
